/**选项卡**/
<template>
    <div class="XKTabs clear">
        <div class="shade shadeLeft">
            <img src="../../../../assets/img/001(1).png">
        </div>
        <div class="XKTabsContent" ref="XKTabsContent">
            <ul class="clear" :style="{width:ulWidth}">
              <li v-for="(itme,index) in servesTypeNav" :style="{width:liWidth}"
                  :class="itme.url==fullPath?'tabAction':''"
                  @click="clickFn(index)"
                  ref="lis"
              >
        <span class="tab">
          <router-link :to="{path:itme.url}">{{itme ? itme.name : ''}}</router-link>
        </span>
                </li>
            </ul>
        </div>
        <div class="shade shadeRight">
            <img src="../../../../assets/img/001(1).png">
        </div>
        <span class="gengduo" @click="allBusinessButFn" :class="AllState?'gengduoShow':''">
      <i class="iconfont icon-yingyong" :style="ulScroll"></i>
    </span>
        <div class="allBusiness" :class="AllState?'allBusinessShow':''">
            <h2>全部服务</h2>
            <div class="Content">
        <span class="row" v-for="(itme,index) in servesTypeNav" @click="allBusinessButFn(true,index)">
          <router-link :to="{path:itme.url}">{{itme ? itme.name : ''}}</router-link>
        </span>
            </div>
        </div>
        <div class="modal" v-if="AllState" @click="allBusinessButFn"></div>
    </div>
</template>

<script>
  //  import Toucth from '../../../../assets/js/method'
  import { mapGetters } from 'vuex'

  export default {
    name: 'Xk-tabs',
    props: ['data', 'acNum'],
    computed: {
      ...mapGetters({
        servesTypeNav: 'servesTypeNav'
      }),
      fullPath: function () {
        return this.$route.fullPath
      }
    },
    data () {
      return {
        dataInfo: this.servesTypeNav,
        action: this.$props.acNum,
        ulWidth: '100%',
        ulScroll: 0,
        liWidth: '6rem',
        AllState: false
      }
    },
    watch: {
      servesTypeNav (val) {
        let that = this
        if (val && val.length < 4) {
          that.ulWidth = '100%'
          that.liWidth = (100 / val.length) + '%'
        } else {
          that.ulWidth = (6 * val.length) + 'rem'
          that.liWidth = '6rem'
        }

        function scroll () {
          let XKTabsContent = that.$refs.XKTabsContent
          let maxscroll = 0
          XKTabsContent.addEventListener('scroll', function (event) {
            let scrollLeft = XKTabsContent.scrollLeft
            if (XKTabsContent.scrollWidth === XKTabsContent.clientWidth + scrollLeft) {
              maxscroll = scrollLeft
            } else if ((XKTabsContent.scrollWidth + 3) < XKTabsContent.clientWidth + scrollLeft) {
              let cha = scrollLeft - maxscroll
              that.ulScroll = {
                transform: 'translate(-50%,-50%) rotate(' + cha * 5 + 'deg) ',
                opacity: (1 - (cha * 0.01))
              }
            } else {
              that.ulScroll = {
                transform: 'translate(-50%,-50%) rotate(0deg) ',
                opacity: 1
              }
            }
          })
        }

        scroll()
        if (val.length > 0 && that.$route.path === '/') {
          that.$router.push(val[0].url)
        }
      }
    },
    methods: {
      clickFn: function (index) {
        this.action = index
        this.menusState = false
        this.AllState = false
        let li = this.$refs.lis[index]
        this.$refs.XKTabsContent.scrollLeft = li.offsetLeft - li.offsetWidth
      },
      allBusinessButFn: function (state, index) {
        this.AllState = !this.AllState
        if (index) {
          let li = this.$refs.lis[index]
          this.$refs.XKTabsContent.scrollLeft = li.offsetLeft - li.offsetWidth
        }
      }
    },
    mounted: function () {
      let that = this
      let val = this.servesTypeNav
      if (val && val.length < 4) {
        that.ulWidth = '100%'
        that.liWidth = (100 / val.length) + '%'
      } else {
        that.ulWidth = (6 * val.length) + 'rem'
        that.liWidth = '6rem'
      }

      if (val.length > 0 && that.$route.path === '/') {
        that.$router.push(val[0].url)
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less">
    .XKTabs {
        width: 100%;
        height: 100%;
        z-index: 100;
        position: relative;
        min-height: 3.8rem;
        .XKTabsContent {
            width: calc(~'100% - 2.8rem');
            height: inherit;
            overflow: hidden;
            overflow-x: auto;
            float: left;
            box-shadow: 0 0 10px rgba(255, 255, 255, 1) inset;
            ul {
                width: auto;
                min-width: 100%;
            }
            li {
                float: left;
                text-align: center;
                font-size: 1.25rem;
                transition: 0.3s all;
                a {
                    color: #333;
                    transition: 0.3s all;
                }
            }
            .tabAction {
                a {
                    color: #f06553;
                }
            }
        }
        .shade {
            position: absolute;
            height: inherit;
            z-index: 10;
            width: 2rem;
            img {
                height: 100%;
                width: 100%;
            }
        }
        .shadeLeft {
            left: -0.2rem;
            top: 0;
            img {
                transform: rotate(180deg);
            }
        }
        .shadeRight {
            right: 2.78rem;
            top: 0;
        }
        .gengduo {
            float: right;
            width: 2rem;
            height: 2rem;
            position: absolute;
            right: 0;
            top: 50%;
            transform: translate(0, -50%);
            transform-origin: 50% 50%;
            border-radius: 50%;
            overflow: hidden;
            z-index: 10;
            i {
                font-size: 1.25rem;
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%) rotate(0deg);
                opacity: 1
            }
        }
        .gengduoShow {
            i {
                transition: 0.3s all;
                transform: translate(-50%, -50%) rotate(180deg);
            }
        }
        .allBusiness {
            box-sizing: border-box;
            position: absolute;
            left: -3.5rem;
            top: 89%;
            background-color: #fff;
            width: 100vw;
            padding: 1rem;
            text-align: center;
            box-shadow: 0 5px 5px rgba(0, 0, 0, .05);
            transform-origin: 0 0;
            transform: scale(1, 0);
            transition: 0.3s all;
            opacity: 0;
            z-index: 50;
            h2 {
                display: inline-block;
                border-bottom: 1px solid #eee;
                width: 100%;
            }
            .Content {
                width: 100%;
                padding: 0.5rem 0;
                .row {
                    line-height: 4rem;
                    float: left;
                    width: 25%;
                    a {
                        color: #333;
                    }
                }
            }
        }
        .allBusinessShow {
            transform: scale(1, 1);
            opacity: 1;
            z-index: 20;
        }
        .modal {
            position: fixed;
            left: 0;
            top: 3.7rem;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, .5);
        }
    }
</style>



// WEBPACK FOOTER //
// tabs.vue?3825626b